export default "__VITE_ASSET__j$EFmuda__"